const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function getDoctorDisplayName(doctor) {
  if (!doctor) return '';
  const name = [doctor.firstName, doctor.lastName].filter(Boolean).join(' ');
  return name ? `Dr ${name}` : '';
}

// Formats: "09:30 PM" (default) or "9:30 pm" (unpaddedHours + lowercase)
export function formatTime(timeStr, options = {}) {
  if (!timeStr) return '';
  const { lowercase = false, unpaddedHours = false } = options;
  const [h, m] = timeStr.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 || 12;
  const hourStr = unpaddedHours ? String(hour) : (hour < 10 ? '0' + hour : '' + hour);
  const minStr = m < 10 ? '0' + m : '' + m;
  const result = hourStr + ':' + minStr + ' ' + ampm;
  return lowercase ? result.toLowerCase() : result;
}

export function formatDateLabel(dateStr) {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  const d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  return `${d.getDate()} ${MONTHS[d.getMonth()]}, ${DAYS[d.getDay()]}`;
}

export function formatDisplayDate(dateStr) {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  const d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  if (d.getTime() === today.getTime()) return 'Today';
  if (d.getTime() === tomorrow.getTime()) return 'Tomorrow';
  return MONTHS[d.getMonth()] + ' ' + d.getDate();
}

export function parseDisplayDate(dateStr) {
  const parts = dateStr.split('-');
  const d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  let displayDay;
  if (d.getTime() === today.getTime()) {
    displayDay = 'Today';
  } else if (d.getTime() === tomorrow.getTime()) {
    displayDay = 'Tomorrow';
  } else {
    displayDay = DAYS[d.getDay()];
  }
  return { date: dateStr, displayDay, displayDate: String(d.getDate()) };
}

export function getSlotHour(slot) {
  return parseInt(slot.start.split(':')[0], 10);
}
